import PropTypes from 'prop-types';
import RadioIcon from '../atoms/readio-icon.atom';

const CustomRadioInput = ({ checked, onChange, value, name, label, disabled = false, id }) => {
  return (
    <label
      style={{
        ...styles.container,
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={styles.input}
        id={id}
      />
      <RadioIcon checked={checked} />
      <span style={{ ...styles.label, fontWeight: checked ? 600 : 400 }}>{label}</span>
    </label>
  );
};

const styles = {
  container: {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '8px 0px',
  height: '40px',
  gap: '16px',
  width: 'fit-content',
  },
  input: {
    display: 'none',
  },
label: {
  flex: '1 0 0',
  color: 'var(--Text-Dark-text, #2C2B2B)',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '24px',
},

};

CustomRadioInput.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default CustomRadioInput;
